import { getDb, serverTimestamp } from '../firebase/firestore.js';
import { collection, addDoc, query, getDocs, orderBy } from 'firebase/firestore';

/**
 * Agrega un voto a un evento
 * @param {string} eventId - ID del evento
 * @param {string} voteValue - Valor del voto: 'positivo', 'neutral', 'negativo'
 * @param {Object} metadata - Datos adicionales del voto
 * @param {string} metadata.uid - ID del usuario (anon o autenticado)
 * @param {string} [metadata.deviceId] - ID del dispositivo
 * @returns {Promise<boolean>}
 */
export const addVote = async (eventId, voteValue, { uid, deviceId = null }) => {
  try {
    const db = getDb();
    const votesRef = collection(db, 'events', eventId, 'votes');
    await addDoc(votesRef, {
      value: voteValue, // 'positivo', 'neutral', 'negativo'
      uid: uid,
      deviceId: deviceId,
      createdAt: serverTimestamp()
    });
    console.log('[VotesRepo] ✅ Voto agregado:', voteValue, 'en evento:', eventId);
    return true;
  } catch (error) {
    console.error('[VotesRepo] ❌ Error adding vote:', error);
    throw error;
  }
};

/**
 * Obtiene votos de un evento
 * @param {string} eventId - ID del evento
 * @param {Date} [fechaInicio] - Filtro opcional inicio
 * @param {Date} [fechaFin] - Filtro opcional fin
 * @returns {Promise<Array>} Array de votos
 * 
 * Nota: Para filtrar por rango de fecha en subcolección, se necesita índice compuesto en Firestore
 * si vamos a ordenar y filtrar a la vez. Aquí simplificamos trayendo todos y filtrando en memoria.
 * Para eventos con muchos votos, usar Cloud Function que agregue datos.
 */
export const getVotesByRange = async (eventId, fechaInicio, fechaFin) => {
  try {
    console.log('[VotesRepo] Fetching votes para evento:', eventId);
    const db = getDb();
    const votesRef = collection(db, 'events', eventId, 'votes');
    
    // Query básica ordenada por fecha
    const q = query(votesRef, orderBy('createdAt', 'asc'));
    
    const querySnapshot = await getDocs(q);
    const votes = [];
    querySnapshot.forEach((doc) => {
      votes.push({ id: doc.id, ...doc.data() });
    });
    
    console.log('[VotesRepo] Votos encontrados:', votes.length, votes);
    
    // Filtrado en memoria si se pasaron fechas
    if (fechaInicio || fechaFin) {
      return votes.filter(vote => {
        const voteDate = vote.createdAt?.toDate?.() || new Date(vote.createdAt);
        if (fechaInicio && voteDate < fechaInicio) return false;
        if (fechaFin && voteDate > fechaFin) return false;
        return true;
      });
    }
    
    return votes;
  } catch (error) {
    console.error('[VotesRepo] ❌ Error fetching votes:', error);
    return [];
  }
};
